module.exports = __webpack_public_path__ + "static/media/calendar.6cf61553.svg";